module.exports = __webpack_public_path__ + "static/media/ind6.8c96ba89.svg";